const PATH = 'app/Analytics';

export const LOAD_RATING_REQUEST = `${PATH}LOAD_RATING_REQUEST`;
export const LOAD_RATING_ERROR = `${PATH}LOAD_RATING_ERROR`;
export const LOAD_RATING_LOADING = `${PATH}LOAD_RATING_LOADING`;
export const LOAD_RATING_SUCCESS = `${PATH}LOAD_RATING_SUCCESS`;
export const LOAD_CUSTOMER_SUMMARY_REQUEST = `${PATH}LOAD_CUSTOMER_SUMMARY_REQUEST`;
export const LOAD_CUSTOMER_SUMMARY_ERROR = `${PATH}LOAD_CUSTOMER_SUMMARY_ERROR`;
export const LOAD_CUSTOMER_SUMMARY_LOADING = `${PATH}LOAD_CUSTOMER_SUMMARY_LOADING`;
export const LOAD_CUSTOMER_SUMMARY_SUCCESS = `${PATH}LOAD_CUSTOMER_SUMMARY_SUCCESS`;